import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import White_Btn from "../../../common/common-btn/white-btn/White_Btn";
import Form_Header from "../../../common/form-header/Form_Header";
import Full_Screen_Modal from "../../../full-screen-modal/Full_Screen_Modal";
import { Registration_Lottie } from "../../../lotties/registration-lottie/Registration_Lottie";
import "./Create_Step6.css";
import Preview_Modal from "../../../common/common-modal/preview-modal/Preview_Modal";
import Time_Modal from "../../../common/common-modal/time-modal/Time_Modal";
import Facilitiy_Modal from "../../../common/common-modal/facilitiy_modal/Facilitiy_Modal";
import Aminities_Modal from "../../../common/common-modal/aminities-modal/Aminities_Modal";
import Key_Services_Modal from "../../../common/common-modal/key-services-modal/Key_Services_Modal";

const Create_Step6 = ({ step, totalSteps, setStep }) => {
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm();
  const [showDocs, setShowDocs] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [step6View, setStep6View] = useState("form");
  const [showModal, setShowModal] = useState(false);
  const fileRef = useRef(null);
  const workoutFileRef = useRef(null);
  const [workoutImages, setWorkoutImages] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);

  const [modalShow, setModalShow] = useState(false);
  const [modalFile, setModalFile] = useState(null);
  const [showTimeModal, setShowTimeModal] = useState(false);

  const [openingTime, setOpeningTime] = useState("06:00");
  const [openingPeriod, setOpeningPeriod] = useState("AM");
  const [closingTime, setClosingTime] = useState("03:00");
  const [closingPeriod, setClosingPeriod] = useState("PM");

  const [schedule1, setSchedule1] = useState(null);
  const [showFacilityModal, setShowFacilityModal] = useState(false);

  const handleDone = () => {
    const label = `${openingTime} ${openingPeriod} - ${closingTime} ${closingPeriod}`;
    setSchedule1({ value: label, label });
    setShowTimeModal(false);
  };

  const openPreviewModal = (file) => {
    setModalFile(file);
    setModalShow(true);
  };

  const handleWorkoutClick = () => {
    workoutFileRef.current.click();
  };

  const handleWorkoutChange = (e) => {
    const files = Array.from(e.target.files);

    const newImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setWorkoutImages((prev) => [...prev, ...newImages]);
  };

  const removeWorkoutImage = (index) => {
    setWorkoutImages((prev) => prev.filter((_, i) => i !== index));
  };

  // ========== upload file  ==============

  const fileRefs = {
    cover: useRef(null),
    logo: useRef(null),
  };

  const [files, setFiles] = useState({
    cover: null,
    logo: null,
  });

  const handleFileChange = (type, e) => {
    const file = e.target.files[0];
    if (file) {
      setFiles((prev) => ({
        ...prev,
        [type]: {
          file,
          name: file.name,
          preview: URL.createObjectURL(file),
        },
      }));
    }
  };

  const handleButtonClick = (type) => {
    if (files[type]?.preview) {
      openPreviewModal(files[type]);
    } else {
      fileRefs[type].current.click();
    }
  };

  const [fileData, setFileData] = useState(null);

  // ======== SINGLE FLIE UPLOAD ==========
  const singleFileRef = useRef(null);
  const [singleFile, setSingleFile] = useState(null);
  const [showFacilityMdoal, setShowFacilityMdoal] = useState(null);
  const [showAminitiesModal, setShowAminitiesModal] = useState(null);
  const [showkeyServicesModal, setShowkeyServicesModal] = useState(false);

  console.log("showFacilityMdoal", showFacilityMdoal);

  const handleSingleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSingleFile({
        file,
        name: file.name,
        preview: URL.createObjectURL(file),
      });
    }
  };

  const handleSingleButtonClick = () => {
    if (singleFile?.preview) {
      openPreviewModal(singleFile);
    } else {
      singleFileRef.current.click();
    }
  };

  const servicesOptions = [
    { value: "Weight Training", label: "Weight Training" },
    { value: "Cardio", label: "Cardio" },
    {
      value: "Group Classes (Yoga/Zumba)",
      label: "Group Classes (Yoga/Zumba)",
    },
    { value: "Personal Training", label: "Personal Training" },
    { value: "Sauna/Spa", label: "Sauna/Spa" },
    { value: "Nutrition Counselling", label: "Nutrition Counselling" },
  ];

  const daysOptions = [
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
    { value: "Sunday", label: "Sunday" },
  ];

  const timeOptions = [
    { value: "6:00 am - 3:00 pm", label: "6:00 am - 3:00 pm" },
    { value: "6:00 am - 3:00 pm", label: "6:00 am - 3:00 pm" },
    { value: "6:00 am - 3:00 pm", label: "6:00 am - 3:00 pm" },
    { value: "6:00 am - 3:00 pm", label: "6:00 am - 3:00 pm" },
  ];

  const countOptions = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
  ];

  const amenitiesOptions = [
    { value: "Locker", label: "Locker" },
    { value: "Shower", label: "Shower" },
    { value: "Changing Room", label: "Changing Room" },
    { value: "Saunas & Steam Rooms", label: "Saunas & Steam Rooms" },
    { value: "Washroom", label: "Washroom" },
    { value: "Shoe Racks", label: "Shoe Racks" },
    { value: "Towel Service", label: "Towel Service" },
  ];

  const facilitiesOptions = [
    { value: "CCTV", label: "CCTV" },
    { value: "Wi Fi", label: "Wi Fi" },
    { value: " Bike Parking", label: "Bike Parking" },
    { value: "Car Parking", label: "Car Parking" },
    { value: "Sanitizer", label: "Sanitizer" },
    { value: "Drinking Water", label: "Drinking Water" },
    { value: "Childcare", label: "Childcare" },
  ];

  /* ---------------- IMAGE PAGE ---------------- */

  if (step6View === "images") {
    return (
      <>
        <section className="step3_wrapper step1_wrapper step4_wrapper step6_wrapper">
          <Form_Header
            title="Upload Gym Images"
            subtitle=""
            step={6}
            totalSteps={6}
          />

          <div className="container mt-4">
            <div className="row mt-4">
              <div className="col-lg-12 mb-4">
                <Form.Group>
                  <Form.Label onClick={() => setShowAminitiesModal(true)}>
                    Amenities Offered
                  </Form.Label>
                  <Select
                    options={amenitiesOptions}
                    placeholder="Select Services"
                    onMenuOpen={() => setShowAminitiesModal(true)}
                    menuIsOpen={false}
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </Form.Group>
              </div>

              <div className="col-lg-12 mb-4">
                <Form.Group>
                  <Form.Label onClick={() => setShowFacilityModal(true)}>
                    Other Facilities
                  </Form.Label>

                  <Select
                    placeholder="Click to select facilities"
                    onMenuOpen={() => setShowFacilityModal(true)}
                    menuIsOpen={false}
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                </Form.Group>
              </div>

              {[
                { label: "Cover Photo", key: "cover" },
                { label: "Gym Logo", key: "logo" },
              ].map((item) => (
                <div className="col-lg-6 mb-4" key={item.key}>
                  <Form.Group>
                    <Form.Label>{item.label}</Form.Label>

                    <div className="file_upload_wrapper">
                      <span className="file_placeholder">
                        {files[item.key]
                          ? files[item.key].name
                          : "No File Uploaded"}
                      </span>

                      <div
                        className="upload_btn"
                        onClick={() => handleButtonClick(item.key)}
                      >
                        <Common_Btn
                          btnText={files[item.key] ? "Preview" : "Upload file"}
                        />
                      </div>

                      <input
                        ref={fileRefs[item.key]}
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={(e) => handleFileChange(item.key, e)}
                      />
                    </div>
                  </Form.Group>
                </div>
              ))}

              <div className="col-lg-12">
                <Form.Label>Workout Space</Form.Label>

                <div className="workout_upload_wrapper">
                  {/* Add Photo Card */}
                  <div className="add_photo_box" onClick={handleWorkoutClick}>
                    <div className="plus_sign_div">
                      <span className="plus_sign">+</span>
                    </div>
                    <p className="add_photo">Add Photo</p>
                  </div>

                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    hidden
                    ref={workoutFileRef}
                    onChange={handleWorkoutChange}
                  />

                  {/* Existing Images */}
                  <div className="workout_images_container">
                    {workoutImages.map((img, index) => (
                      <div className="workout_image_card" key={index}>
                        <img
                          src={img.preview}
                          alt="Workout"
                          className="workout_img"
                        />

                        <span
                          className="remove_image"
                          onClick={() => removeWorkoutImage(index)}
                        >
                          ✕
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="form_btn_holder">
              <White_Btn btnText="Back" onClick={() => setStep6View("form")} />
              <Common_Btn
                btnText="Next"
                onClick={() => setStep6View("declaration")}
              />
            </div>
          </div>
        </section>

        {/* -------- Preview Modal -------- */}
        <Preview_Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          file={modalFile}
          onUploadNew={() => {
            if (modalFile === singleFile) {
              singleFileRef.current.click();
            } else {
              const key = Object.keys(files).find(
                (k) => files[k] === modalFile
              );
              fileRefs[key]?.current.click();
            }
          }}
          onDelete={() => {
            if (modalFile === singleFile) {
              setSingleFile(null);
            } else {
              const key = Object.keys(files).find(
                (k) => files[k] === modalFile
              );
              setFiles((prev) => ({ ...prev, [key]: null }));
            }
            setModalShow(false);
          }}
        />

        <Facilitiy_Modal
          show={showFacilityModal}
          onHide={() => setShowFacilityModal(false)}
        />

        <Aminities_Modal
          show={showAminitiesModal}
          onHide={() => setShowAminitiesModal(false)}
        />
      </>
    );
  }

  /* ================= FORM VIEW ================= */
  if (step6View === "form") {
    return (
      <>
        <section className="step3_wrapper step1_wrapper step4_wrapper step6_wrapper">
          <Form_Header
            title="About Gold's Gym"
            subtitle=""
            step={6}
            totalSteps={6}
          />
          <div className="container">
            <Form className="auth_form">
              <div className="row">
                <div className="col-lg-12 mb-4">
                  <Form.Group>
                    <Form.Label>Key Services Offered</Form.Label>

                    <Select
                      placeholder="Select your legal structure"
                      onMenuOpen={() => setShowkeyServicesModal(true)}
                      menuIsOpen={false}
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  </Form.Group>
                </div>

                <div className="col-lg-6 mb-4">
                  <Form.Group>
                    <Form.Label>Working Days and Timings</Form.Label>
                    <Select
                      options={daysOptions}
                      placeholder="Select Day (from)"
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  </Form.Group>
                </div>

                <div className="col-lg-6 mb-4">
                  <Form.Group>
                    <Form.Label>Weekend</Form.Label>
                    <Select
                      options={daysOptions}
                      placeholder="Select Day (to)"
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  </Form.Group>
                </div>

                <div className="col-lg-6 mb-4">
                  <Form.Group>
                    <Form.Label>Weekend</Form.Label>
                    <Select
                      options={daysOptions}
                      placeholder="Select Day"
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  </Form.Group>
                </div>
                <div className="col-lg-6 mb-4"></div>

                <div className="col-lg-6 mb-4">
                  <Form.Group>
                    <Form.Label>Schedule 1</Form.Label>

                    <Select
                      value={schedule1}
                      placeholder="Enter Time"
                      onMenuOpen={() => setShowTimeModal(true)}
                      menuIsOpen={false}
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  </Form.Group>
                </div>

                <Time_Modal
                  show={showTimeModal}
                  onHide={() => setShowTimeModal(false)}
                  openingTime={openingTime}
                  setOpeningTime={setOpeningTime}
                  openingPeriod={openingPeriod}
                  setOpeningPeriod={setOpeningPeriod}
                  closingTime={closingTime}
                  setClosingTime={setClosingTime}
                  closingPeriod={closingPeriod}
                  setClosingPeriod={setClosingPeriod}
                  onDone={handleDone}
                />

                <div className="col-lg-6 mb-4">
                  <Form.Group>
                    <Form.Label>Schedule 2</Form.Label>
                    <Select
                      value={schedule1}
                      placeholder="Enter Time"
                      onMenuOpen={() => setShowTimeModal(true)}
                      menuIsOpen={false}
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  </Form.Group>
                </div>

                <div className="col-lg-11 mb-4">
                  <Form.Group>
                    <Form.Label>Geo Location</Form.Label>
                    <Form.Control type="text" placeholder="Enter Manually" />
                  </Form.Group>
                </div>
                <div className="col-lg-1 mb-4">
                  <Form.Group>
                    <Form.Label></Form.Label>
                  </Form.Group>
                  <div className="location_icon_holder">
                    <FontAwesomeIcon
                      icon={faLocationDot}
                      style={{ fontSize: "25px" }}
                    />
                  </div>
                </div>

                <div className="col-lg-12 mb-4">
                  <Form.Group>
                    <Form.Label>
                      Gym Description (Max. 500 characters)
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Gym Description"
                    />
                  </Form.Group>
                </div>

                <div className="col-lg-6 mb-4">
                  <Form.Group>
                    <Form.Label>Total staff count</Form.Label>
                    <Select
                      options={countOptions}
                      placeholder="Staff Count"
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  </Form.Group>
                </div>
              </div>
            </Form>

            <div className="form_btn_holder">
              <White_Btn btnText={"Back"} onClick={() => setStep(5)} />
              <Common_Btn
                btnText={"Next"}
                onClick={() => setStep6View("images")}
              />
            </div>
          </div>
        </section>

        <Key_Services_Modal
          show={showkeyServicesModal}
          onHide={() => setShowkeyServicesModal(false)}
        />
      </>
    );
  }

  /* ================= DECLARATION VIEW ================= */
  return (
    <>
      <section className="step6_wrapper step3_wrapper step1_wrapper step4_wrapper">
        <Form_Header
          title="About Gold's Gym"
          subtitle=""
          step={6}
          totalSteps={6}
        />

        <div className="container mt-5">
          <div className="declaration_text_holder">
            <h5 className="top_title">You are almost there...</h5>
            <h4 className="top_subtitle">Declaration and Authorization</h4>
            <p className="declaration_text">
              I, hereby confirm that all the information provided in this
              registration form is true and correct, & the attached documents
              are authentic and valid under Indian legal protocols. I am duly
              authorized to enter into this Tie-Up Agreement with GYMIFY on
              behalf of the above-named business entity.
            </p>

            <p className="declaration_text">
              I understand that GYMIFY reserves the right to verify all
              documents and information before approving the registration.
            </p>
          </div>

          <div className="row align-items-center">
            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Date of Declaration</Form.Label>
                <Form.Control type="date" />
              </Form.Group>
            </div>

            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Place</Form.Label>
                <Form.Control type="text" placeholder="Enter Place" />
              </Form.Group>
            </div>

            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Digital Signature</Form.Label>
                <div className="file_upload_wrapper">
                  <span className="file_placeholder">
                    {singleFile ? singleFile.name : "No File Uploaded"}
                  </span>

                  <div className="upload_btn" onClick={handleSingleButtonClick}>
                    <Common_Btn
                      btnText={singleFile ? "Preview" : "Upload file"}
                    />
                  </div>

                  <input
                    ref={singleFileRef}
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={handleSingleFileChange}
                  />
                </div>
              </Form.Group>
            </div>

            <div className="col-lg-12 mb-4">
              <Form.Check
                type="checkbox"
                label="By continuing, I agree to the Terms of Use & Privacy Policy"
                className="label_form"
              />
            </div>
          </div>

          <div className="form_btn_holder">
            <White_Btn btnText="Back" onClick={() => setStep6View("images")} />
            <Common_Btn btnText="Register" onClick={() => setStep(7)} />
          </div>
        </div>
      </section>

      {/* -------- Preview Modal -------- */}
      <Preview_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        file={modalFile}
        onUploadNew={() => {
          if (modalFile === singleFile) {
            singleFileRef.current.click();
          } else {
            const key = Object.keys(files).find((k) => files[k] === modalFile);
            fileRefs[key]?.current.click();
          }
        }}
        onDelete={() => {
          if (modalFile === singleFile) {
            setSingleFile(null);
          } else {
            const key = Object.keys(files).find((k) => files[k] === modalFile);
            setFiles((prev) => ({ ...prev, [key]: null }));
          }
          setModalShow(false);
        }}
      />
    </>
  );
};

export default Create_Step6;
